import React from "react"
import { WebVersion } from "../../services"
import { useDeviceUtils } from "../../utils/useDeviceUtils"
import { Caption } from "../Headings"

const ErrorVersionDisplay = ({ sentryError }) => {
  const { deviceClientInfo } = useDeviceUtils()

  const getDeviceVersion = () => {
    if (deviceClientInfo?.app?.version) {
      return deviceClientInfo.app.version
    }
    return null
  }

  const deviceVersion = getDeviceVersion()

  return (
    <Caption tiny>
      Web: {WebVersion}
      {deviceVersion && <> | Device: {deviceVersion}</>}
      {sentryError && <> | {sentryError}</>}
    </Caption>
  )
}

export default ErrorVersionDisplay
